export default {
  backendURL: 'https://neue.wissensbank.com/api',
  coverURL: 'https://neue.wissensbank.com/api'
};